import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import _ from 'lodash';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
import { validateInputField } from '../../utils/form-builder.util';
export const TextInputFormComponent = ({ label, elementKey, defaultValue, onChange, password, value, inputValidation, isDisabled = false, }) => {
    const onInputChange = (e) => {
        onChange(elementKey, e.target.value);
    };
    const errorMessage = React.useMemo(() => validateInputField(value, inputValidation), [value]);
    return (React.createElement(FormControl, { label: label, className: styles.formComponentItem, errorMessage: errorMessage, hasError: !_.isEmpty(errorMessage), noMarginBottom: true, "data-testid": `test-id-${elementKey}` },
        React.createElement(Input.Text, { value: value ?? defaultValue, ariaLabel: label, type: password ? 'password' : 'text', key: elementKey, onChange: onInputChange, disabled: isDisabled })));
};
//# sourceMappingURL=text-input-form.component.js.map